import IndustryShowcasePage from "./IndustryShowcasePage";

export default function IndustryShowcase() {
  return <IndustryShowcasePage isPublic={false} />;
}
